/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ListGroup from 'react-bootstrap/ListGroup';
import { ExternalLinkIcon } from '@heroicons/react/solid';

import * as S from './styles';

export interface IMultiColListProps {
  data: {
    key: string;
    title: string;
    subtitle: string;
    icon: string;
  }[];
  numberOfColumns: '1' | '2' | '3' | '4';
}

function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

function start_and_end(str) {
  if (str.length > 25) {
    return (
      str.substr(0, 10) + '.....' + str.substr(str.length - 10, str.length)
    );
  }
  return str;
}

export const MultiColList = (props: IMultiColListProps) => {
  const { data, numberOfColumns } = props;

  const _renderColSize = () => {
    switch (numberOfColumns) {
      case '1':
        return 12;
      case '2':
        return 6;
      case '3':
        return 4;
      case '4':
        return 3;
      default:
        return 4;
    }
  };
  const _renderSubtitleIf = (subtitle: string) => {
    if (subtitle) {
      if (isValidHttpUrl(subtitle)) {
        return (
          <a href={subtitle} target={'_blank'}>
            {start_and_end(subtitle)}
            <ExternalLinkIcon className="icon icon-xs ms-2" />
          </a>
        );
      }
      return subtitle;
    }
    return '';
  };
  const _renderList = () => {
    return (
      <>
        {data.map((item, index) => {
          return (
            <Col xs={12} md={_renderColSize()} key={`${item?.key}-${index}`}>
              <ListGroup>
                <S.IconContainer>
                  {item?.icon && <S.IconImage src={item?.icon} />}
                  <div className="px-3 pb-2">
                    {/*<S.Title className="fs-6 mb-0 pb-0">*/}
                    {/*  {item?.title ?? ""}*/}
                    {/*</S.Title>*/}
                    <p
                      className="fs-6 mb-0 w-100 align-justify"
                      style={{
                        fontWeight: 'bold',
                        color: '#ABABAB',
                      }}
                    >
                      {item?.title ?? ''}
                    </p>
                    <p
                      className="fs-6 text-dark mb-0 w-100 align-justify"
                      style={{ wordBreak: 'break-all' }}
                    >
                      {_renderSubtitleIf(item?.subTitle)}
                    </p>
                  </div>
                </S.IconContainer>
              </ListGroup>
            </Col>
          );
        })}
      </>
    );
  };
  return <Row className="flex-start">{_renderList()}</Row>;
};

MultiColList.defaultProps = {
  data: [],
  numberOfColumns: '3',
};
